import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export async function submitContact(payload) {
    const { data } = await api.post("/contact", payload);
    return data;
}

export async function fetchProjects(category) {
    const params = category && category !== "All" ? { category } : {};
    const { data } = await api.get("/projects", { params });
    return data;
}
